import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions = {
  resource: ResourceEnum.Condition,
  smallIcon: <i className="icon-15-conditions" />,
  bigIcon: <i className="icon-20-conditions" />,
};
